/*
 * @Author: guanxiaoyan guanxiaoyan@pb-station.com
 * @Deion: 
 * @Date: 2024-01-24 14:16:43
 * @LastEditors: guanxiaoyan guanxiaoyan@pb-station.com
 * @LastEditTime: 2024-01-24 14:56:20
 * @FilePath: /ywx-open/vueproject/src/api/admin/userManage/staff.js
 */
import request from "@/utils/followUp/request";

const BASE_URL = "/internal/doctor";

// 员工（医生）管理-分页列表
export function staffPageList(query) {
  return request({
    url: `${BASE_URL}/selectDoctorPage`,
    method: "get",
    params: query,
  });
}

// 员工（医生）管理-获取医网信医生列表
export function getTrustDoctorInfos(query) {
  return request({
    url: `${BASE_URL}/getTrustDoctorInfos`,
    method: "get",
    params: query,
  });
}

// 员工（医生）管理-已开通权限的医生ID
export function getAllDoctorIdForClient() {
  return request({
    url: `${BASE_URL}/getAllDoctorIdForClient`,
    method: "get",
  });
}

// 员工（医生）管理-批量添加
export function batchAddStaff(data) {
  return request({
    url: `${BASE_URL}/saveBatch`,
    method: "post",
    data,
  });
}

// 员工（医生）管理-编辑员工科室院区
export function editStaff(data) {
  return request({
    url: `${BASE_URL}/editDoctor`,
    method: "post",
    data,
  });
}

// 员工（医生）管理-删除
export function delStaff(id) {
  return request({
    url: `${BASE_URL}/del/${id}`,
    method: "post",
  });
}
